import script from "./popup-software-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./popup-software-list.vue?vue&type=script&setup=true&lang=ts"

import "./popup-software-list.vue?vue&type=style&index=0&id=bd183fee&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd183fee"]])

export default __exports__